import styled from 'styled-components';

export const CharacterWrapper = styled.div`
    align-self: end
`;

export const CharacterImg = styled.img`
    height: 900px;
    display: block
`;
